<template>
    <div>
        <div class="content-header">
            <div class="container-fluid">
                <div class="row mb-2">
                    <div class="col-sm-6">
                        <h1 class="m-0  text-capitalize">Game Financial Metrics</h1>
                    </div>
                    <div class="col-sm-6">
                        <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item">
                                <router-link to="/">Home</router-link>
                            </li>
                            <li class="breadcrumb-item active text-capitalize"><i class="fas fa-list"></i> Game Financial Metrics
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <section class="content">
            <div class="container-fluid">
                <data-table-wrapper
                    ref="dataTable"
                    :columns="columns"
                    :filters="filters"
                    :filter-defaults="filterDefaults"
                    :cell-style-option="cellStyleOption"
                    :on-data-load="onDataLoad"
                    disable-primary-column="true"
                    disable-edit-action="true"
                    disable-delete-action="true"
                    :endpoint="'/game-financial-metrics'"
                    api-service="analytics"
                    sort-column-default="timestamp"
                    sort-order-default="DESC"
                >
                    <template v-slot:filter-buttons>
                        <button class="btn btn-default float-right" @click="doExport">
                            <span v-if="!exportInProgress">
                                <i class="fa fa-cloud-download"></i> {{ $t('Export') }}
                            </span>
                            <span v-else>
                                <i class="fas fa-spinner fa-pulse"></i> {{ $t('Export') }}
                            </span>
                        </button>
                    </template>
                </data-table-wrapper>
            </div>

        </section>
    </div>
</template>

<script>
import DataTableWrapper from '../components/DataTableWrapper';
import {mapGetters} from "vuex";
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';
import * as dateUtils from "@/helpers/dateUtils";
import * as formatUtils from "@/helpers/formatUtils";

export default {
    components: {
        DataTableWrapper,
        VueJsonPretty
    },
    data() {
        return {
            exportInProgress: false,
            onDataLoad: () => {
                let els = document.getElementsByClassName('vjs-tree');
                Array.from(els).forEach((el) =>  {
                    if (el?.firstElementChild?.firstElementChild?.firstElementChild?.firstElementChild?.firstElementChild?.innerText === '{') {
                        el.firstElementChild.firstElementChild.firstElementChild.firstElementChild.firstElementChild.click();
                    }
                })
            },
            cellStyleOption: {
                bodyCellClass: ({ column }) => {
                    if (column.field === 'state' || column.field === 'sessionKey') {
                        return 'small-text';
                    }
                },
            },
            filters: [
              {
                field: 'fromDate',
                placeholder: 'From Date',
                label: 'From Date',
                type: 'date-picker',
                shortcuts: dateUtils.getFilterShortcuts()
              },
              {
                field: 'toDate',
                placeholder: 'To Date',
                label: 'To Date',
                type: 'date-picker',
                shortcuts: dateUtils.getFilterShortcuts()
              },
            ],
        };
    },
    computed: {
        ...mapGetters([
            'getGames',
            'getGame',
            'getPartners',
            'getPartner',
            'getOperators',
            'getOperator',
            'getCurrency',
            'isOperator',
        ]),
        columns() {
            let columns = [
                {
                    field: 'gameid',
                    title: 'Game',
                    sorting: true
                },
                {
                    field: 'name',
                    title: 'Name',
                    sorting: true
                },
                {
                    field: 'arppu',
                    title: 'ARPPU',
                    sorting: false,
                    callback: ({row}) => this.formatNumber(row.arppu),
                },
                {
                    field: 'lt',
                    title: 'LT',
                    sorting: false,
                    callback: ({row}) => this.formatNumber(row.lt),
                },
                {
                    field: 'ltv',
                    title: 'LTV',
                    sorting: false,
                    callback: ({row}) => this.formatNumber(row.ltv),
                },
                {
                    field: 'ftsdynamics',
                    title: 'FTSDynamics',
                    sorting: false,
                },
                {
                    field: 'spin_conversion',
                    title: 'Spin conversion',
                    sorting: false,
                    callback: ({row}) => this.formatNumber(row.spin_conversion),
                },
                {
                    field: 'average_bill',
                    title: 'Average bill',
                    sorting: false,
                    callback: ({row}) => this.formatNumber(row.average_bill),
                },
                {
                    field: 'average_bet',
                    title: 'Average bet',
                    sorting: false,
                    callback: ({row}) => this.formatNumber(row.average_bet),
                },
                {
                    field: 'slot_revenue_perc',
                    title: 'Slot revenue perc',
                    sorting: false,
                    callback: ({row}) => this.formatNumber(row.slot_revenue_perc),
                },
                {
                    field: 'real_rtp',
                    title: 'Real RTP',
                    sorting: false,
                    callback: ({row}) => this.formatNumber(row.real_rtp),
                },
                {
                    field: 'real_volatility',
                    title: 'Real volatility',
                    sorting: false,
                     callback: ({row}) => this.formatNumber(row.real_volatility),
                },
            ];
            return columns;
        },
        filterDefaults() {
            return {
              fromDate: dateUtils.getTodayDate()
            }
        }
    },
    methods: {
        formatNumber(value) {
          if (value === null || value === undefined || value === '') {
            value = 0;
          }
          return formatUtils.formatNumberToFixed(value,2);
        },
        doExport() {
            if (this.exportInProgress) {
                return;
            }
            this.exportInProgress = true;
            this.$exportService.doExport('game-financial-metrics', this.$refs.dataTable.getPageQuery()).finally(() => {
                this.exportInProgress = false;
            });
        },
    },
    mounted() {
    },
};
</script>
